export default {
    EDIT_FOLDER: "Редактировать",
    DELETE_FOLDER: "Удалить",
    CONFIRM_DELETE_FOLDER_TEXT: "Вы уверены, что хотите удалить папку? Все файлы, которые находятся внутри папки, будут также удалены.",
    CONFIRM_DELETE_FOLDER_HEADER: "Удалить папку"
};
